import type { Card, Suit } from './cards.js';

/** One card played to a trick, by the seat (or player) that played it. */
export interface TrickPlay<Seat> {
  readonly seat: Seat;
  readonly card: Card;
}

/** The cards a hand may play: follow the suit led if possible, otherwise anything; a leader (no `led`) may play any card. */
export function followSuit(hand: readonly Card[], led: Suit | undefined): Card[] {
  if (!led) return [...hand];
  const follows = hand.filter((c) => c.suit === led);
  return follows.length > 0 ? follows : [...hand];
}

/**
 * The winner of a completed trick: the highest trump if any was played, else the highest card of the
 * suit led. `trump` is null for a hand without trump.
 */
export function trickWinner<Seat>(plays: readonly TrickPlay<Seat>[], trump: Suit | null): Seat {
  const led = (plays[0] as TrickPlay<Seat>).card.suit;
  const trumped = trump === null ? [] : plays.filter((p) => p.card.suit === trump);
  const pool = trumped.length > 0 ? trumped : plays.filter((p) => p.card.suit === led);
  return pool.reduce((best, p) => (p.card.rank > best.card.rank ? p : best)).seat;
}
